import styled from 'styled-components';

export const Item = styled.div`
  padding: 10px;
  margin: 0 0 10px 0;
  border-radius: 5px;
  background: #e8e8e8;
  cursor: move;
`;
